import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import * as XLSX from 'xlsx';
import {
  CITIES, CINSIYET, MEDENI_HAL, EGITIM, EHLIYET, isValidTCKN,
  EXCEL_TEMPLATE_HEADERS, EXCEL_SAMPLE_ROWS, EXCEL_TEMPLATE_INFO,
} from './formOptions';

const UserForm = () => {
  const [realname, setRealname] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState('');
  const [company, setCompany] = useState('');
  const [eposta, setEposta] = useState('');
  const [dogumt, setDogumt] = useState('');
  const [girist, setGirist] = useState('');
  const [egitimd, setEgitimd] = useState('');
  const [annead, setAnnead] = useState('');
  const [babaad, setBabaad] = useState('');
  const [cinsiyet, setCinsiyet] = useState('');
  const [medenih, setMedenih] = useState('');
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCity2, setSelectedCity2] = useState("");
  const [adres, setAdres] = useState("");
  const [ehliyet, setEhliyet] = useState("");
  const [userTCKN, setUserTCKN] = useState("");
  const [fotoFile, setFotoFile] = useState(null);
  const [base64Foto, setBase64Foto] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [excelLoading, setExcelLoading] = useState(false);
  const [excelResult, setExcelResult] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isTCKNValid, setIsTCKNValid] = useState(true);

  const cities = CITIES;

  const handleTCKNChange = (e) => {
    const value = e.target.value;
    setUserTCKN(value);
    setIsTCKNValid(!value || isValidTCKN(value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userData = {
      realname, username, password, phone, company, status, eposta,
      dogumt, girist, egitimd, annead, babaad, cinsiyet, selectedCity,
      selectedCity2, adres, ehliyet, userTCKN, medenih,
      photo: base64Foto,
    };

    try {
      const response = await fetch('https://api.idekod.com.tr/api/users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
      });

      if (response.ok) {
        toast.success('Kullanıcı başarıyla eklendi!', { position: "top-center", autoClose: 3000 });
        setRealname(''); setUsername(''); setPassword(''); setPhone(''); setCompany('');
        setStatus(''); setEposta(''); setDogumt(''); setGirist(''); setEgitimd('');
        setAnnead(''); setBabaad(''); setCinsiyet(''); setSelectedCity(''); setSelectedCity2('');
        setAdres(''); setEhliyet(''); setUserTCKN(''); setMedenih(''); setBase64Foto(null);
      } else {
        toast.error('Kullanıcı ekleme başarısız oldu.', { position: "top-center", autoClose: 3000 });
      }
    } catch (error) {
      console.error('Hata:', error);
      toast.error('Bir hata oluştu. Lütfen tekrar deneyin.', { position: "top-center", autoClose: 3000 });
    }
  };

  // Fotoğraf seçimi (Excel seçimiyle karıştırılmamalı)
  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Foto(reader.result);
      setFotoFile(URL.createObjectURL(file));
    };
    reader.readAsDataURL(file);
  };

  const handleExcelChange = (e) => {
    setExcelFile(e.target.files?.[0] || null);
    setExcelResult(null);
  };

  // Şablonu tarayıcıda üretir; böylece sütunlar her zaman API ile aynı kalır
  const downloadTemplate = () => {
    const wb = XLSX.utils.book_new();

    const ws = XLSX.utils.json_to_sheet(EXCEL_SAMPLE_ROWS, { header: EXCEL_TEMPLATE_HEADERS });
    ws['!cols'] = EXCEL_TEMPLATE_HEADERS.map((h) => ({ wch: Math.max(14, h.length + 4) }));
    XLSX.utils.book_append_sheet(wb, ws, 'Personeller');

    const wsInfo = XLSX.utils.aoa_to_sheet(EXCEL_TEMPLATE_INFO);
    wsInfo['!cols'] = [{ wch: 24 }, { wch: 10 }, { wch: 62 }];
    XLSX.utils.book_append_sheet(wb, wsInfo, 'Açıklama');

    XLSX.writeFile(wb, 'kullanici-sablon.xlsx');
  };

  const handleExcelSubmit = async (e) => {
    e.preventDefault();
    if (!excelFile) return;

    setExcelLoading(true);
    setExcelResult(null);

    const formData = new FormData();
    formData.append('file', excelFile);

    try {
      const response = await fetch('https://api.idekod.com.tr/api/users/excel', {
        method: 'POST',
        body: formData
      });
      const data = await response.json().catch(() => null);

      if (!response.ok || !data?.success) {
        setExcelResult({
          type: 'error',
          text: data?.message || 'Excel dosyasından kullanıcı ekleme başarısız oldu.',
          errors: data?.hatalar || [],
        });
      } else {
        setExcelResult({
          type: data.failed ? 'warning' : 'success',
          text: data.message,
          errors: data.hatalar || [],
          columns: data.okunanSutunlar || [],
        });
      }
    } catch (error) {
      console.error('Hata:', error);
      setExcelResult({ type: 'error', text: 'Sunucuya ulaşılamadı.', errors: [] });
    } finally {
      setExcelLoading(false);
    }
  };

  return (
    <div className="page">
      <ToastContainer />
      <div className="page__head">
        <div>
          <h1 className="page__title">Personel Kayıt</h1>
          <p className="page__subtitle">Yeni personel ekleyin veya Excel ile toplu aktarım yapın</p>
        </div>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">Kullanıcı Bilgileri</h2>
        </div>

        <form onSubmit={handleSubmit} className="card__body form">
          <div className="form-field">
            <label className="form-label">Fotoğraf Yükle</label>
            {fotoFile && <img src={fotoFile} alt="Seçilen Fotoğraf" className="photo-preview u-mb-2" />}
            <input type="file" accept="image/*" onChange={handlePhotoChange} className="form-control" />
          </div>

          <div className="form-grid">
            <div className="form-field">
              <label className="form-label">T.C. Kimlik Numarası</label>
              <input
                type="text"
                value={userTCKN}
                onChange={handleTCKNChange}
                required
                className={`form-control ${!isTCKNValid ? 'form-control--invalid' : ''}`}
              />
              {!isTCKNValid && <span className="form-error">Geçersiz TCKN</span>}
            </div>

            <div className="form-field">
              <label className="form-label">Kullanıcı Ad Soyad</label>
              <input type="text" value={realname} onChange={(e) => setRealname(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">Kullanıcı ID</label>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">Şifre</label>
              <div className="input-with-icon">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="form-control"
                  placeholder="Şifrenizi giriniz"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="input-with-icon__action"
                  title={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M13.828 10l4.39-4.39a1 1 0 00-1.415-1.415L12.414 8.586 8 4.172a1 1 0 10-1.415 1.415l4.39 4.39-4.39 4.39a1 1 0 101.415 1.415l4.414-4.414 4.39 4.39a1 1 0 001.415-1.415L13.828 10z" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 3c-4.5 0-8 3.58-8 5s3.5 5 8 5 8-3.58 8-5-3.5-5-8-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="form-field">
              <label className="form-label">Telefon</label>
              <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">Cinsiyet</label>
              <select value={cinsiyet} onChange={(e) => setCinsiyet(e.target.value)} required className="form-control">
                <option value="">Seçiniz</option>
                {CINSIYET.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>

            <div className="form-field">
              <label className="form-label">Medeni Hal</label>
              <select value={medenih} onChange={(e) => setMedenih(e.target.value)} required className="form-control">
                <option value="">Seçiniz</option>
                {MEDENI_HAL.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>

            <div className="form-field">
              <label className="form-label">Eğitim Durumu</label>
              <select value={egitimd} onChange={(e) => setEgitimd(e.target.value)} required className="form-control">
                <option value="">Seçiniz</option>
                {EGITIM.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>

            <div className="form-field">
              <label className="form-label">Ehliyet</label>
              <select value={ehliyet} onChange={(e) => setEhliyet(e.target.value)} required className="form-control">
                <option value="">Seçiniz</option>
                {EHLIYET.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>

            <div className="form-field">
              <label className="form-label">Şehir</label>
              <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)} className="form-control">
                <option value="">Şehir seçiniz...</option>
                {cities.map((city) => <option key={city} value={city}>{city}</option>)}
              </select>
            </div>

            <div className="form-field">
              <label className="form-label">Doğum Yeri</label>
              <select value={selectedCity2} onChange={(e) => setSelectedCity2(e.target.value)} className="form-control">
                <option value="">Şehir seçiniz...</option>
                {cities.map((city) => <option key={city} value={city}>{city}</option>)}
              </select>
            </div>

            <div className="form-field">
              <label className="form-label">Anne Ad Soyad</label>
              <input type="text" value={annead} onChange={(e) => setAnnead(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">Baba Ad Soyad</label>
              <input type="text" value={babaad} onChange={(e) => setBabaad(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">Durum (0-Pasif / 1-Aktif / 3-Bekleyen)</label>
              <input type="text" value={status} onChange={(e) => setStatus(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">Şirket Kısa Kod</label>
              <input type="text" value={company} onChange={(e) => setCompany(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">E-posta</label>
              <input type="email" value={eposta} onChange={(e) => setEposta(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">Doğum Tarihi</label>
              <input type="date" value={dogumt} onChange={(e) => setDogumt(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field">
              <label className="form-label">İşe Başlangıç Tarihi</label>
              <input type="date" value={girist} onChange={(e) => setGirist(e.target.value)} required className="form-control" />
            </div>

            <div className="form-field form-field--full">
              <label className="form-label">Adres</label>
              <input type="text" value={adres} onChange={(e) => setAdres(e.target.value)} required className="form-control" />
            </div>
          </div>

          <button type="submit" className="btn btn--primary btn--block btn--lg">Kaydet</button>
        </form>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">Excelden Toplu Aktar</h2>
          <p className="card__subtitle">
            Kayıt formundaki tüm alanlar Excel ile aktarılabilir. Sütun sırası önemli değildir;
            başlık adları şablondaki gibi olmalıdır.
          </p>
        </div>

        <form onSubmit={handleExcelSubmit} className="card__body form">
          <div className="form-field">
            <label className="form-label">Excel Dosyası (.xlsx, .xls)</label>
            <input
              type="file"
              accept=".xlsx, .xls"
              onChange={handleExcelChange}
              required
              className="form-control"
            />
            <span className="form-helper">
              Zorunlu sütunlar: Ad Soyad, Kullanıcı Adı, Telefon.
            </span>
          </div>

          <div className="btn-group">
            <button type="submit" className="btn btn--primary" disabled={!excelFile || excelLoading}>
              {excelLoading ? 'Aktarılıyor…' : 'Excelden Aktar'}
            </button>
            <button type="button" onClick={downloadTemplate} className="btn btn--ghost">
              Örnek Şablonu İndir
            </button>
          </div>

          {excelResult && (
            <div
              className={`info-banner ${
                excelResult.type === 'error'
                  ? 'info-banner--error'
                  : excelResult.type === 'warning'
                  ? 'info-banner--warning'
                  : 'info-banner--success'
              }`}
            >
              <strong>{excelResult.text}</strong>

              {excelResult.columns?.length > 0 && (
                <div className="u-mt-2" style={{ fontWeight: 400 }}>
                  Okunan sütunlar: {excelResult.columns.join(', ')}
                </div>
              )}

              {excelResult.errors?.length > 0 && (
                <ul className="import-errors">
                  {excelResult.errors.map((h, i) => (
                    <li key={i}>Satır {h.satir}: {h.hata}</li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default UserForm;
